import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonHeader,
  IonButton,
  IonFooter,
  IonLabel,
  IonTextarea,
  useIonViewDidEnter,
  IonInput,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import SelectSectionCustom from "../components/SelectSectionCustom";
import { v4 as uuidv4 } from "uuid";
import { Link, useHistory } from "react-router-dom";
import { Assessment } from "../models/AssessmentRelated/Assessment";
import { currentAssessmentState, PatientState } from "../data/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  CompleteTest,
  CompleteTestPhase,
  GenerateTestsReport,
  StartAssessment,
  StartTest,
} from "../services/AssessmentsService";
import { TestType, VisitTypes } from "../models/Enums";
import { convertDOBintoAge } from "../utils/sharedFunction";
// function AssessmentNotes() {
const AssessmentNotes: React.FC = () => {
  function formatAMPM(date: any) {
    // console.log("date", date)
    var hours = date.getHours();
    var minutes = date.getMinutes();
    // console.log("hours", hours)
    // console.log("minutes", minutes)
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    // console.log("strTime", strTime)
    return strTime;
  }
  const getCurrentDay = () => {
    let d = new Date();
    let dayName = d.toString().split(" ");
    return (
      dayName.slice(0, 2).join(", ") + " " + dayName.slice(2, 4).join(", ")
    );
  };
  const getLocalStringDate = () => {
    let date = new Date();
    return date.toLocaleDateString();
  };

  const [patientName, setPatientName] = useState(
    localStorage.getItem("patientName")!
  );
  const [patientInfo, setPatientInfo] = useRecoilState(PatientState);

  const [date, setDate] = useState(getCurrentDay());
  const [time, setTime] = useState(formatAMPM(new Date()));
  const [visitType, setVisitType] = useState<any>();
  const [isDropDown, setIsDropDown] = useState<boolean>(false);
  const [lookType, setLookupType] = useState<any>("");
  const [note, setNote] = useState("");
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState
  );
  const [patientAge, setpatientAge] = useState(0);
  const btnref = useRef<HTMLIonButtonElement>(null);
  const visitTypes = [
    { id: VisitTypes.Discharge, name: "Discharge" },
    { id: VisitTypes.InitialEvaluation, name: "Initial Evaluation" },
    { id: VisitTypes.Reassessment, name: "Reassessment" },
    { id: VisitTypes.Screen, name: "Screen" },
  ];
  // let currentAssessment: Assessment = useRecoilValue(currentAssessmentState);
  let history = useHistory();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getFormData = () => {
    btnref.current?.setAttribute("disabled", "true");
    // console.log(new Date())
    // console.log(new Date().toLocaleTimeString())
    // console.log(new Date().toDateString())
    // console.log(new Date().toISOString())
    // console.log(new Date().toTimeString())
    // console.log(new Date().toUTCString())
    let localtime = new Date(
      new Date().setHours(
        new Date().getHours() - new Date().getTimezoneOffset() / 60
      )
    ).toISOString();

    CompleteTestPhase({
      TestId: currentAssessment.testId,
      AdmissionDateUTC: localtime,
      LocalDateTime: localtime,
      UTCDateTime: localtime,
      StartTime: localtime,
      StartTimeUTC: localtime,
      EndTime: localtime,
      EndTimeUTC: localtime,
      TestJson: currentAssessment.testJson,
    })
      .then((result: any) => {
        // console.log('current Assessment data : ', currentAssessment);
        // console.log('result response : ', result);
        setcurrentAssessmentState((prevState: Assessment) => ({
          ...prevState,
          phaseId: result.data.id,
        }));
        // console.log("visittype: ", visitType)
        CompleteTest({
          TestId: currentAssessment?.testId,
          VisitId: currentAssessment?.visitId,
          //  IsInComplete: currentAssessment.testId,
          PatientId: localStorage.getItem("patientServerID"),
          // TestLookupId:  TestType.gait,
          TestLookupId: currentAssessment.assessmentType
            ? currentAssessment.assessmentType
            : 0,
          MasterTestId: currentAssessment.masterTestId,
          PhaseId: result.data.id,
          VisitType: visitType?.id,
          Comments: note,
        })
          .then(async (res: any) => {
            if (res.data.responseCode == 1) {
              let summaryDetail = {
                date: date,
                dateFormat: getLocalStringDate(),
                time: time,
                visitType: visitType,
                note: note,
              };
              setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
              // let patientAge;
              // if (localStorage.getItem("patientdob")!) {
              //   // let dob = JSON.parse(localStorage.getItem("patientdob")!);
              //   patientAge = convertDOBintoAge(new Date(localStorage.getItem("patientdob")!));
              // }
              // else {
              //   patientAge = 45
              // }
              // console.log("patientAge", patientAge);
              let assessmentSummaryArray = JSON.parse(
                localStorage.getItem("summaryDetail") || "[]"
              );
              let getJSONSummary = JSON.parse(
                localStorage.getItem("Assesment Summary")!
              );
              let assessmentID = uuidv4();
              let patientServerID = localStorage.getItem("patientServerID")
                ? localStorage.getItem("patientServerID")
                : "000";
              let patientName = localStorage.getItem("patientName")
                ? localStorage.getItem("patientName")!
                : "Name Required";
              getJSONSummary = {
                assessmentID: assessmentID,
                patientServerID: patientServerID,
                patientName: patientName,
                patientAge: patientAge,
                ...summaryDetail,
                ...getJSONSummary,
              };
              assessmentSummaryArray.push(getJSONSummary);
              localStorage.setItem(
                "summaryDetail",
                JSON.stringify(assessmentSummaryArray)
              );
              localStorage.setItem(
                "selectedAssesment",
                JSON.stringify(assessmentID)
              );
              setTimeout(() => {
                history.replace("/patient-assessment-summary", {
                  pageHeaderText: "Full Visit Summary",
                  isAssessmentCompleted: false,
                });
              }, 200);
            }
          })
          .catch((err) => {
            btnref.current?.setAttribute("disabled", "false");
            console.error(err);
          });

        // console.log(result);
      })
      .catch((err) => {
        btnref.current?.setAttribute("disabled", "false");
        console.error(err);
      });
  };

  const getVisitType = (e: any) => {
    setVisitType(parseInt(e.detail.value));
    // console.log("event",e.detail.value);
  };
  const getNoteText = (e: any) => {
    setNote(e.detail.value);
    // console.log("event",e.detail.value);
  };
  useIonViewDidEnter(() => {
    console.log("ionViewDidEnter event fired");
    //setNote("");
    //   setVisitType(undefined);
  });
  let location =
    window.location.href == window.location.origin + "/assessment-notes"
      ? true
      : false;
  useEffect(() => {
    setPatientName(localStorage.getItem("patientName")!);
    setDate(getCurrentDay());
    setTime(formatAMPM(new Date()));

    console.log(currentAssessment);
  }, [location]);

  // console.log("PAT AGE: ", patientAge)
  // console.log("visitType ", visitType);
  return (
    <>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <IonGrid
            className="container create-patient-pages assessmet-notes-main-header"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="top-inner-sec assements-note-page">
                  <div className="left-arrow">
                    <svg
                      onClick={() => {
                        history.goBack();
                      }}
                      className="svg-icons"
                      width="16"
                      height="26"
                      viewBox="0 0 16 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                        fill="#31344E"
                        stroke="black"
                      />
                    </svg>
                  </div>
                  <h1>Enter Assessment Notes</h1>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid
            className="container assessment-notes-container"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="visit-summary-inner-sec assessment-notes-inner-wrap">
                  {/* <h3> James Baker </h3>
                  <h4>Friday - Feb 4, 2022</h4>
                  <div className="visit-summary-inner-detail">
                    <p>Visit summary info will go here.Visit summary info will go here.</p>
                  </div> */}
                  <div className="assements-notes">
                    <ul>
                      <li>{date}</li>
                      <li>{time}</li>
                      <li>{patientName}</li>
                      {localStorage.getItem("TherapistName") !== undefined && (
                        <li>{localStorage.getItem("TherapistName")!}</li>
                      )}
                      {/* {
                        currentAssessment && currentAssessment !== undefined && 
                          <li>{currentAssessment?}</li>
                      } */}
                    </ul>
                  </div>
                </div>
                <div className="field-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    Visit Types
                  </IonLabel>

                  {/* <IonSelect placeholder="Select Visit Types" value={visitType.toString()} onIonChange={(e) => { getVisitType(e) }}>
                    <IonSelectOption value="1">Screen</IonSelectOption>
                    <IonSelectOption value="2">Initial Evaluation</IonSelectOption>
                    <IonSelectOption value="3">Reassessment</IonSelectOption>
                    <IonSelectOption value="4">Discharge</IonSelectOption>
                  </IonSelect> */}

                  <div className="select-wrap-sec">
                    {/* <IonInput
                      className="input-field"
                      type="text"
                      value="Select Visit Types"
                      readonly
                    >
                    </IonInput> */}
                    {/* <div className="select-option-wrap"> */}
                    <SelectSectionCustom
                      isEdit={true}
                      placeholder="Select a visit type"
                      isSearchable={false}
                      isEditableOption={false}
                      allOptions={visitTypes}
                      value={""}
                      onAddOrEditLookUp={() => {}}
                      isMultiSelect={false}
                      LookUpType={"VisitType"}
                      onSelectOption={setVisitType}
                    />

                    {/* <ul>
                        <li className="option-wrapper">
                        <div className="option-name">Screen</div>
                        </li>
                        <li className="option-wrapper">
                        <div className="option-name">Initial Evaluation</div>
                        </li>
                        <li className="option-wrapper">
                        <div className="option-name">Reassessment</div>
                        </li>
                        <li className="option-wrapper">
                        <div className="option-name">Screen</div>
                        </li>
                      </ul> */}
                    {/* </div> */}
                  </div>
                </div>
                <IonLabel className="label" placeholder={undefined}>
                  Assessment Notes
                </IonLabel>
                <div className="card-bg">
                  <IonTextarea
                    placeholder="Enter Notes here..."
                    value={note ? note : ""}
                    rows={6}
                    onIonChange={(e) => {
                      getNoteText(e);
                    }}
                  ></IonTextarea>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        <IonFooter
          className="ion-no-border end-session-footer"
          placeholder={undefined}
        >
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                {/* <Link
                    to="/report-page"
                    className="ancher-generic-btn text-dec-none"
                  >
                  Submit and End Assessment
                </Link> */}
                <IonButton
                  ref={btnref}
                  className="generic-btn"
                  type="submit"
                  onClick={() => {
                    getFormData();
                  }}
                  placeholder={undefined}
                >
                  Submit and End Assessment
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
      </IonPage>
    </>
  );
};
export default AssessmentNotes;
